import React from 'react';
import PropTypes from 'prop-types';
import { PageSection, SectionBody } from './PageSection';
import RichText from './RichText';
import { Paragraph, Box, Heading } from 'grommet';
import styled, { css } from 'styled-components';
import { ButtonContainer, Button } from './Button';

const StyledCard = styled(Box)``;

const Card = ({ name, title, body, ctaLabel, ctaUrl }) => {
  return (
    <StyledCard background={'light-1'} pad={'40px'}>
      <Box pad={{ bottom: '1rem' }}>
        <Heading level="3">{name}</Heading>
        <Paragraph color={'#000'} style={{paddingTop: '10px'}}>{title}</Paragraph>
      </Box>
      <RichText richText={body} />
      <ButtonContainer>
        <Button label={ctaLabel} href={ctaUrl} />
      </ButtonContainer>
    </StyledCard>
  );
};

Card.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.object.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
};

// Cards
const StyledCards = styled.div`
  display: grid;
  grid-gap: var(--gutters);
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  justify-content: center;
  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    ${({ theme, $cardsCount }) => {
      //  SINGLE CARD
      if ($cardsCount === 1)
        return css`
          grid-template-columns: minMax(auto, 420px);
        `;
      //  THIRDS
      if ($cardsCount % 3 === 0)
        return css`
          grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
        `;
      //  Everything else
      return css`
        grid-template-columns: 1fr 1fr;
      `;
    }}
  }
`;
const Cards = ({ items }) => {
  return (
    <StyledCards $cardsCount={items.length}>
      {items.map((item, index) => {
        return <Card {...item} key={`${index}-${item.title}`} />;
      })}
    </StyledCards>
  );
};

Cards.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(Card.PropTypes)),
};

// Section
const LargeCardsSection = ({ title, items, ...rest }) => {
  return (
    <PageSection {...rest}>
      <SectionBody>
        <Box pad={{ bottom: '2rem' }} align={'center'}>
          <Heading level="3" align="center">
            {title}
          </Heading>
        </Box>
        <Cards items={items} />
      </SectionBody>
    </PageSection>
  );
};

LargeCardsSection.propTypes = {
  title: PropTypes.string.isRequired,
  ...Cards.propTypes,
};

export default LargeCardsSection;
